import Footer from '../../sections/footer/Footer'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import HeaderSolid from '../../sections/header/HeaderSolid'

import './style.scss'
import CtaButton from '../../components/ctaButton/CtaButton'
import { useState } from 'react'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { loginConnector } from '../../server/connector/loginConnector'

function ResetPassword() {

	const [resettingPassword, setResettingPassword] = useState<boolean>(false)
	const [email, setEmail] = useState<string>('')

	const [resetRequestDone, setResetRequestDone] = useState<boolean>(false)

	const resetClicked = () => {
		setResettingPassword(true)
		loginConnector.performResetPasswordRequest(email).then((successRequest) => {
			if (successRequest) {
				setResetRequestDone(true)
				setResettingPassword(false)
				// window.location.replace(PAGE_URLS.LOG_IN)
			}
		})
	}
	
	return (
		<>
			<div className='section-wrap section-seperator'>
				<HeaderSolid />
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<div className='sign-up-content'>
						<div className='sign-up-content-section'>
							<div className='sign-up-form'>
								<div className='sign-up-form-title'>Forgot Password?</div>
								<input 
									className='sign-up-form-input' 
									type={'email'} 
									placeholder={'Email Address *'} 
									value={email}
									onChange={(event) => {
										setEmail(event.target.value)
									}}
									disabled={resettingPassword}
								/>
								{resetRequestDone && <div className='sign-up-form-login-failed'>
									Email has been sent to the address with a link to reset that password
								</div>}
								<CtaButton
									label={resettingPassword ? 'Resetting...' : 'Reset'}
									size='medium'
									onClick={() => resetClicked()}
									fullWidth={true}
									disabled={
										email === '' ||
										resettingPassword ||
										resetRequestDone == true
									}
								/>
								<div className='line-text-span-wrap'>
									<div className='line-text-span-wrap-span'>or</div>
								</div>
								<div className='sign-already-have-account'><a href={PAGE_URLS.LOG_IN}>Log in</a></div>
							</div>
						</div>
						<div className='sign-up-content-section log-in-picture-section'>
							<img
								className='sign-up-picture'
								alt='Ski Lift'
								src='/imgs/pictures/ski-lift.png'
							/>
						</div>
					</div>
				</div>
			</div>
			<div className='section-wrap section-seperator'>
				<div className='section-content'>
					<Footer />
				</div>
			</div>
			<BackToTopButton />
		</>
	)
}

export default ResetPassword
